import type { Bootgrid } from "./bootgrid";

export function initializeColumnDragAndDrop(bootgrid: Bootgrid, table: HTMLTableElement) {
    let draggedElement: HTMLElement | null = null;
    const draggableElements = table.querySelectorAll('th[draggable="true"]:not(th[data-column-id="commands"])') as NodeListOf<HTMLElement>;
    draggableElements.forEach((draggableElement) => {
        draggableElement.addEventListener("dragstart", (event) => {
            draggedElement = draggableElement;
            draggedElement.style.opacity = "0.5";
        });

        draggableElement.addEventListener("dragover", (event) => {
            event.preventDefault();
            if (!draggedElement) return;
            const targetElement = event.target as Element;
            const targetParent = targetElement.closest("th");
            if (targetParent && !targetParent.classList.contains("drop-left") && !targetParent.classList.contains("drop-right")) {
                const thRect = targetParent.getBoundingClientRect();
                targetParent.classList.remove("drop-left", "drop-right");
                targetParent.classList.add(isLeftHalf(event as DragEvent, thRect) ? "drop-left" : "drop-right");
            }
        });

        draggableElement.addEventListener("dragleave", (event) => {
            if (!draggedElement) return;
            const targetElement = event.target as Element;
            const targetParent = targetElement.closest("th");
            if (targetParent) {
                targetParent.classList.remove("drop-left", "drop-right");
            }
        });

        draggableElement.addEventListener("drop", (event) => {
            event.preventDefault();
            if (!draggedElement) return;
            const targetElement = event.target as Element;
            const targetParent = targetElement.closest("th");

            if (targetParent && draggedElement !== targetParent) {
                const currentDraggableElements = table.querySelectorAll(
                    'th[draggable="true"]:not(th[data-column-id="commands"])'
                ) as NodeListOf<HTMLElement>;
                const targetParentDisplayIndex = Array.from(currentDraggableElements).findIndex((el) => el === targetParent);
                const draggedElementDisplayIndex = Array.from(currentDraggableElements).findIndex((el) => el === draggedElement);
                const thRect = targetParent.getBoundingClientRect();
                const dropPosition = isLeftHalf(event as DragEvent, thRect) ? "beforebegin" : "afterend";

                if (
                    (targetParentDisplayIndex + 1 === draggedElementDisplayIndex && dropPosition === "afterend") ||
                    (targetParentDisplayIndex - 1 === draggedElementDisplayIndex && dropPosition === "beforebegin")
                )
                    return;

                targetParent.insertAdjacentElement(dropPosition, draggedElement);
                const columnSettings = ($(table) as any).bootgrid("getColumnSettings");
                const targetParentIndex = columnSettings.findIndex((column: any) => column.id === targetParent.dataset.columnId);
                const draggedColumnIndex = columnSettings.findIndex((column: any) => column.id === draggedElement.dataset.columnId);
                let targetIndex = targetParentIndex + (dropPosition === "beforebegin" ? -1 : 0);
                if (draggedColumnIndex > targetIndex) {
                    targetIndex = targetIndex + 1;
                }
                moveElementInArray(columnSettings, draggedColumnIndex, targetIndex);
                updateColumnOrder(bootgrid, columnSettings);
                bootgrid.stateChangeHandler();
            }
        });

        draggableElement.addEventListener("dragend", (event) => {
            draggedElement.style.opacity = "1";
            draggedElement = null;
            draggableElements.forEach((el) => el.classList.remove("drop-left", "drop-right"));
        });
    });
}

function updateColumnOrder(bootgrid: Bootgrid, columns: any[]) {
    (bootgrid.$bootgrid as any).bootgrid("updateColumnOrder", columns);
    bootgrid.reloadTable();
    bootgrid.stateChangeHandler();
}

function moveElementInArray(array: any[], fromIndex: number, toIndex: number) {
    const elementToMove = array.splice(fromIndex, 1)[0];
    array.splice(toIndex, 0, elementToMove);
    return array;
}

function isLeftHalf(event: DragEvent, thRect: DOMRect) {
    return event.clientX - thRect.left < thRect.width / 2;
}
